import {Component, Input, NgModule, OnInit} from '@angular/core';
import {SubmissionSearchUserInfoObject} from '../../search-object';
import {Subscription} from 'rxjs';
import {SubmissionHistoryService} from '../../../../shared/services/submission-history.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgxChartsModule } from '@swimlane/ngx-charts';

import { colorScheme } from './kpi-color-scheme';
import {KpiService} from '../../../../shared/services/kpi.service';
import {Kpi} from '../interfaces/kpi';

@Component({
  selector: 'kpi-line-chart',
  templateUrl: './kpi-line-chart.component.html',
  styleUrls: ['./kpi-line-chart.component.scss']
})
export class KpiLineChartComponent implements OnInit {

    @Input() userInfo: any;
    @Input() xAxisLabel: string;
    @Input() yAxisLabel: string;
    @Input() graphTitle: any;

    @Input() data: any;
    test: Kpi;
    testJson: any;
    private submissionsPerMonth: Subscription;
    private localSubmissionsPerMonth: Kpi;

    // options
    colorScheme: any[];
    view: any[] = [500, 300];
    legend = false;
    gradient = true;
    showLabels = false;
    animations = true;
    xAxis = true;
    yAxis = true;
    showYAxisLabel = true;
    showXAxisLabel = true;
    timeline = true;

    constructor(private kpiService: KpiService) {
        Object.assign(this, { colorScheme })
    }

    ngOnInit() {
        // this.kpiService.currentAveragePerMonthChart.subscribe(message => this.test = message);
        // this.testJson = JSON.stringify( this.test.submissionKPIs )
   }

    public getKpiInfo() {
    }

    onSelect(data): void {
        console.log('Item clicked', JSON.parse(JSON.stringify(data)));
    }

    onActivate(data): void {
        console.log('Activate', JSON.parse(JSON.stringify(data)));
    }

    onDeactivate(data): void {
        console.log('Deactivate', JSON.parse(JSON.stringify(data)));
    }
}
